import Preloader from '@/ui/Loader/Preloader';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { RootState, useAppSelector } from '@/utils/storage/stores/store';
import { LoadData } from '@/widgets/Load/LoadData';

/** Загрузка корзины */
export const CartPageLoader = ({ children }: { children: React.ReactNode }) => {
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId as number);

    return (
        <LoadData
            reducerName='cart'
            resourceName='cartOffer'
            loader={() => cartOfferLoader({ cartId: cartId || 0, isMini: false })}
            // updatedField='products'
            necessaryUpdate={true}
            preloader={<Preloader />}>
            {children}
        </LoadData>
    );
}